import React from 'react';
import { DEFAULT_IMAGE_DURATION } from '../../../consts';
import { getRepeatsCount } from '../../../utils';
import { DATA_TEST_IDS } from '../consts';
import ImageDurationControl from '../ImageDurationControl';
import VideoRepeatControl from '../VideoRepeatControl';
import type { MediafileDurationControlProps } from './types';

const MediafileDurationControl: React.FC<MediafileDurationControlProps> = ({
  fileId,
  duration,
  playDuration,
  isValid,
  isErrorVisible,
  isDisabled,
  isBlockedDurationEdit,
  onBlur,
  onMouseOut,
  onChange,
}) => {
  if (duration) {
    return (
      <VideoRepeatControl
        elementId={DATA_TEST_IDS.REPEATS(fileId)}
        repeatCount={getRepeatsCount(duration, playDuration)}
        isValid={isValid}
        isErrorVisible={isErrorVisible}
        isDisabled={isDisabled}
        isBlockedDurationEdit={isBlockedDurationEdit}
        onBlur={onBlur}
        onMouseOut={onMouseOut}
        onChange={onChange}
      />
    );
  }

  return (
    <ImageDurationControl
      elementId={DATA_TEST_IDS.DURATION(fileId)}
      helperId={DATA_TEST_IDS.HELPER(fileId)}
      playDuration={isDisabled ? playDuration || DEFAULT_IMAGE_DURATION : playDuration}
      isValid={isValid}
      isErrorVisible={isErrorVisible}
      isDisabled={isDisabled}
      isBlockedDurationEdit={isBlockedDurationEdit}
      onBlur={onBlur}
      onMouseOut={onMouseOut}
      onChange={onChange}
    />
  );
};

export default MediafileDurationControl;
